import { ModalDialog } from "common/Dialog";
import { Form, FormField, PrimaryButton, SecondaryButton } from "common/Forms";
import { TextAreaInput, TextInput } from "common/Forms/inputs";
import { validationRuleFactory } from "common/Forms/validation";
import { ResponsiveGap } from "common/Grid";
import { Grid, GridCell } from "common/Grid/Grid";
import { useMemo, useState } from "react";
import { useInvoiceDownloadMutation } from "store/action/admin-fee";
import { toast } from 'react-toastify';
import { TableView } from './TableView';
import { captureComponentError } from "utils/sentry";

export const AdminFeeStatusCard = ({ feeCards = [] }) => {
  const [validationResult, setValidationResult] = useState({});
  const [downloadInvoiceAPI, { isLoading }] = useInvoiceDownloadMutation()
  const emailValidationRules = useMemo(() => [validationRuleFactory.required("Email can't be empty")], []);
  const [isAddInvoiceAdd, setIsAddInvoiceAdd] = useState(false)
  const [invoiceUserInput, setInvoiceUserInput] = useState({})
  const isValid = Object.values(validationResult).every(x => x)

  const onValidationWrapper = (fieldName, onValidation) => {
    return (isValid, failedResults) => {
      setValidationResult(prev => ({ ...prev, [fieldName]: isValid }));
      onValidation(isValid, failedResults);
    };
  };

  const handleDownloadInvoice = async () => {
    toast.warning('Sending invoice to your email, please wait')
    try {
      const invoiceUserInputToApiInput = {
        email: invoiceUserInput?.email,
        notes: invoiceUserInput?.notes,
        fromDate: invoiceUserInput.fromDate ?? '',
        toDate: invoiceUserInput.toDate ?? '',
        totalAmount: invoiceUserInput.totalAdminFee,
        siteid: invoiceUserInput.siteid ?? '',
        option: invoiceUserInput.option ?? '',
        paymentMethod: invoiceUserInput.paymentMethod ?? '',
      }
      await downloadInvoiceAPI(invoiceUserInputToApiInput).then((res) => {
      if (res?.data?.status === "SUCCESS") {
        toast.success(res?.data?.message || "Invoice sent to your entered email");
        setIsAddInvoiceAdd(false);
      } else {
        toast.error("Something went wrong");
      }})
    } catch (err) {
      captureComponentError(err, { component: "AdminFeeStatusCard", action: "handleDownloadInvoice" });
      if (err?.data?.message) {
        toast.error(err.data.message);
      } else {
        toast.error('Invoice sent error, please try again.');
      }
    }
  };

  const onDownloadInvoice = (feeCard) => {
    setInvoiceUserInput(feeCard);
    setIsAddInvoiceAdd(true);
  };

  return (
    <>
      {feeCards?.length ?
        <TableView
          feeCards={feeCards}
          onDownloadInvoice={onDownloadInvoice} />
        : <>No App Fees Found</>
      }
      <ModalDialog isOpened={isAddInvoiceAdd} title='Download Invoice'>
        <Form>
          <FormField
            id="email"
            name="email"
            label="Email Address"
            inputFactory={(id, name, onValidation) =>
              <TextInput
                id={id}
                name={name}
                type="email"
                placeholder="Enter email"
                onValidation={onValidationWrapper(id, onValidation)}
                validationRules={emailValidationRules}
                value={invoiceUserInput.email}
                onChange={(_, value) => setInvoiceUserInput({ ...invoiceUserInput, email: value })}
              />
            }
          />
          <FormField
            id="notes"
            name="notes"
            label="Email Notes"
            inputFactory={(id, name, onValidation) =>
              <TextAreaInput
                id={id} name={name}
                value={invoiceUserInput?.notes ?? ''}
                placeholder='Enter notes'
                onValidation={onValidation}
                onChange={(_, n) => setInvoiceUserInput({ ...invoiceUserInput, notes: n })}
              />
            }
          />
        </Form>
        <ResponsiveGap left={false} right={false}>
          <Grid columns={2}>
            <GridCell>
              <PrimaryButton disabled={!isValid || isLoading} isWide={true} action={() => handleDownloadInvoice()}>Submit</PrimaryButton>
            </GridCell>
            <GridCell>
              <SecondaryButton action={() => setIsAddInvoiceAdd(false)} isWide={true}>Cancel</SecondaryButton>
            </GridCell>
          </Grid>
        </ResponsiveGap>
      </ModalDialog>
    </>
  )
}